// extracted by mini-css-extract-plugin
module.exports = {"headline-icon-wrapper":"_3_ps8"};